<template>
  <router-view />
</template>

<script>
import storeMixin, { unRegisterMixin } from '@/shared/mixins/storeGenerator';
const STORE_MODULE_NAME = 'CompensatoryServiceModule';

export default {
  name: 'CompensatoryWrapper',
  mixins: [unRegisterMixin, storeMixin],
  data: () => ({
    moduleName: STORE_MODULE_NAME,
  }),
};
</script>
